import {
  ArrowsLeftRightIcon,
  BellIcon,
  BuildingsIcon,
  CalendarBlankIcon,
  CalendarCheckIcon,
  CalendarPlusIcon,
  ClipboardTextIcon,
  ClockIcon,
  EnvelopeIcon,
  FileTextIcon,
  IdentificationBadgeIcon,
  MapPinIcon,
  PlugsConnectedIcon,
  ShieldCheckIcon,
  TagIcon,
  UploadSimpleIcon,
  UserCircleIcon,
  UsersIcon,
} from '@phosphor-icons/react'
import { AISparkleIcon } from 'app/components/Icon/AIBadgeIcon'
import type { RailConfig } from 'lib/railSections'

/** A location's SMS agent tab (`/ai-agent/<id>/sms`) lives outside `/settings` but inside its frame. */
const AI_AGENT_LOCATION_SMS_ROUTE = /^\/ai-agent\/[^/]+\/sms(\/|$)/

export const SETTINGS_RAIL: RailConfig = {
  rowName: `Settings`,
  title: `Settings`,
  homePath: `/settings`,
  routes: [/^\/settings(\/|$)/, AI_AGENT_LOCATION_SMS_ROUTE],
  groups: [
    { id: `you`, label: `You` },
    { id: `practice`, label: `Practice` },
    { id: `people`, label: `People` },
    { id: `data`, label: `Data` },
    { id: `connections`, label: `Connections` },
  ],
  sections: {
    Profile: { group: `you`, Icon: UserCircleIcon },
    Notifications: { group: `you`, Icon: BellIcon },
    Workspace: { group: `practice`, Icon: BuildingsIcon },
    Locations: { group: `practice`, Icon: MapPinIcon },
    Availability: { group: `practice`, Icon: CalendarCheckIcon },
    'Online Scheduler': { group: `practice`, Icon: CalendarPlusIcon },
    Forms: { group: `practice`, Icon: ClipboardTextIcon },
    'Online Scheduling': { group: `practice`, Icon: CalendarBlankIcon },
    'PMS Schedules': { group: `practice`, Icon: ClockIcon },
    'AI Agent': { group: `practice`, Icon: AISparkleIcon },
    Users: { group: `people`, Icon: UsersIcon },
    Staff: { group: `people`, Icon: IdentificationBadgeIcon },
    Roles: { group: `people`, Icon: ShieldCheckIcon },
    Mapping: { group: `data`, Icon: ArrowsLeftRightIcon },
    'Referral Type Mapping': { group: `data`, Icon: ArrowsLeftRightIcon },
    Tags: { group: `data`, Icon: TagIcon },
    Templates: { group: `data`, Icon: FileTextIcon },
    Import: { group: `data`, Icon: UploadSimpleIcon },
    Integrations: { group: `connections`, Icon: PlugsConnectedIcon },
    'Sending Domains': { group: `connections`, Icon: EnvelopeIcon },
  },
  fallbackGroup: `practice`,
  fallbackIcon: BuildingsIcon,
}
